export const General = {
  generalPolicyPrivacy: '#',
  policyPrivacy: '#',
  instagram: 'https://www.instagram.com/babo.gardens/',
  facebook: 'https://www.facebook.com/babogardens/',
  googleApiKey: 'AIzaSyApBEBocUtOkfjXRZYfZ21eszsl4la6Xd0',
  parajanov: 'https://parajanov.com.ua/',
  monspius: 'https://monspius.com.ua/',
  libraria: 'https://libraria.com.ua/',
  centaura: 'https://centaura.com.ua/',
  phone: '(067) 000-15-26',
  phone2: '(096) 019-95-78',
  gAnalyticId: 'G-F6E6J0TG85',
}
